import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from '@mui/material'
import { useCallback, useRef } from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import { forceUploadWikiFiles } from '../../Services/Api/ApiService'
import { useMsal } from '@azure/msal-react'
import { LoadingSpinner, useLoadingSpinner } from '../../Components/LoadingSpinner';

export interface UpdateWikiDialogParameters {
    isOpen: boolean,
    onClose: () => void
}

export const UpdateWikiDialog = (parameters: UpdateWikiDialogParameters) => {
    const { isLoading, startLoading, stopLoading } = useLoadingSpinner();
    const msalContextRef = useRef(useMsal());
    const handleUpdate = useCallback((): void => {
        startLoading();
        forceUploadWikiFiles(msalContextRef.current)
            .finally(() => {
                stopLoading();
                parameters.onClose()
            });
    }, [parameters, startLoading, stopLoading]);

    return (
        <Dialog open={ parameters.isOpen }>
            <DialogTitle>
                Aktualizacja
            </DialogTitle>
            <DialogContent style={{ textAlign: 'center', color: '#c92c2c' }}>
                Czy na pewno chcesz zaktualizować?
                Operacja może zająć około minuty.
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' color='success' startIcon={ <CheckCircleIcon /> } onClick={ handleUpdate }>
                    Potwierdź
                </Button>
                <Button variant='outlined' color='error' startIcon={ <CancelIcon /> } onClick={ parameters.onClose }>
                    Anuluj
                </Button>
            </DialogActions>
            {(isLoading && <LoadingSpinner />)}
        </Dialog>
    )
}